/**
 * @ngdoc constant
 * @name MENU_ITEMS
 * @description
 * Array of menu items
 *
 * @memberof rootModule
 * @type {Object}
 * @property {String}  icon  Menu icon.
 * @property {String}  title Menu title.
 * @property {String}  link  Menu link (the page to redirect on click).
 * @property {Boolean} the item should be displayed in the Menu Bar.
 * @property {Boolean} the Title Bar should be displayed when this item in active.
 * @property {Boolean} the Back button should be displayed when this item in active.
 * @property {Boolean} the Menu Bar should be displayed when this item in active.
 * @property {RegExp}  the RegExp path that matches a menu item with the location path.
 * @property {Boolean} the menu item should include an upload button.
 */
const menuItems = [{
  icon: 'home',
  title: 'Home',
  link: '/home',
  visible: true,
  showTitleBar: true,
  showBackButton: false,
  showMenu: true,
  regExpPath: /^\/home$/,
  includeUploadBtn: false,
}, {
  icon: 'plus-circle',
  title: 'Upload',
  link: '',
  visible: true,
  showTitleBar: true,
  showBackButton: true,
  showMenu: false,
  regExpPath: /^\/upload(?:\/|\/\w+)?$/,
  includeUploadBtn: true,
}, {
  icon: 'users',
  title: 'Community',
  link: '/community',
  visible: true,
  showTitleBar: true,
  showBackButton: true,
  showMenu: true,
  regExpPath: /^\/community$/,
  includeUploadBtn: false,
}, {
  icon: 'user',
  title: 'Me',
  link: '/profile',
  visible: true,
  showTitleBar: true,
  showBackButton: true,
  showMenu: true,
  regExpPath: /^\/profile$/,
  includeUploadBtn: false,
}, {
  icon: '',
  title: 'Campaign',
  link: '',
  visible: false,
  showTitleBar: true,
  showBackButton: true,
  showMenu: true,
  regExpPath: /^\/campaign\/\w+$/,
  includeUploadBtn: false,
}, {
  icon: '',
  title: 'Media',
  link: '',
  visible: false,
  showTitleBar: false,
  showBackButton: false,
  showMenu: false,
  regExpPath: /^\/campaign\/\w+\/media\/\w+|\/community\/media\/\w+|\/profile\/media\/\w+$/,
  includeUploadBtn: false,
}, {
  icon: '',
  title: 'Login',
  link: '',
  visible: false,
  showTitleBar: false,
  showBackButton: false,
  showMenu: false,
  regExpPath: /^\/login$/,
  includeUploadBtn: false,
}, {
  icon: '',
  title: 'Tos',
  link: '',
  visible: false,
  showTitleBar: false,
  showBackButton: false,
  showMenu: false,
  regExpPath: /^\/tos/,
  includeUploadBtn: false,
}];

export default menuItems;



// WEBPACK FOOTER //
// ./src/frontend/modules/root/constants/menu.constants.js